var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaBigCircleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.196,
    cy: 0.967,
    r: 1.087,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedd76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fb741e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#de286f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#a030b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#436def"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram_2",
    "data-name": "Instagram 2",
    transform: "translate(13040 10133.96)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(-13040 -10133.96)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M116.636,135.054c-2.347-.017-4.2-.017-6.059-.048-1.031,0-2.041-.069-3.062-.137a12.214,12.214,0,0,1-4.066-.952,9.5,9.5,0,0,1-5.237-5.454,12.371,12.371,0,0,1-.725-2.983c-.086-.711-.131-1.423-.151-2.138-.034-1.375-.076-2.749-.086-4.145v-6.093c0-.883,0-1.77.031-2.65s.055-1.718.107-2.557a12.955,12.955,0,0,1,1-4.468,9.478,9.478,0,0,1,5.189-5.09,12.132,12.132,0,0,1,3.667-.869c1.656-.148,3.323-.182,4.987-.182h8.959c1.182,0,2.368.065,3.547.144a12.122,12.122,0,0,1,4.086.948,9.489,9.489,0,0,1,5.255,5.5,12.55,12.55,0,0,1,.739,3.165c.089.8.113,1.595.148,2.406.069,1.588.065,3.172.065,4.76v6.454c0,1.182-.058,2.364-.113,3.547a14.056,14.056,0,0,1-.612,3.564,9.791,9.791,0,0,1-1.718,3.285,9.65,9.65,0,0,1-4.351,3.093,12.427,12.427,0,0,1-3.2.687c-.907.072-1.821.127-2.732.144C120.259,135.024,118.2,135.037,116.636,135.054Zm-15.977-18.9v1.766c0,1.718,0,3.413.072,5.12.031.708.055,1.416.148,2.117a8.893,8.893,0,0,0,.653,2.43,6.1,6.1,0,0,0,2.89,3.045,8.31,8.31,0,0,0,3.093.828c.8.069,1.6.11,2.406.134,1.083.034,2.165.048,3.244.048q4.066,0,8.131-.024c1.151,0,2.306-.045,3.437-.155a9.334,9.334,0,0,0,2.54-.577,6.138,6.138,0,0,0,3.347-3.065,8.4,8.4,0,0,0,.808-3.12c.069-.849.11-1.7.134-2.553.031-1.086.041-2.175.045-3.261v-6.038c0-1-.024-2-.052-2.993-.021-.839-.048-1.68-.144-2.516a9.042,9.042,0,0,0-.612-2.457,6.1,6.1,0,0,0-3.017-3.227,8.217,8.217,0,0,0-3.014-.794c-.887-.076-1.773-.12-2.663-.144-1.148-.034-2.3-.045-3.437-.041-3.378,0-6.757-.058-10.131.1a13.509,13.509,0,0,0-2.375.292,7.069,7.069,0,0,0-2.248.89,6.248,6.248,0,0,0-2.619,3.333,10.694,10.694,0,0,0-.526,2.88c-.055,1.031-.1,2.062-.107,3.114-.007,1.608,0,4.852,0,4.852Z",
    transform: "translate(-13126.138 -10220.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M134.35,144.7a10.387,10.387,0,1,1,7.356-3.038A10.391,10.391,0,0,1,134.35,144.7Zm-6.726-10.413a6.745,6.745,0,1,0,2-4.764,6.745,6.745,0,0,0-2,4.764Z",
    transform: "translate(-13144.361 -10238.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M177.416,116.21a2.428,2.428,0,1,1-2.447,2.392A2.429,2.429,0,0,1,177.416,116.21Z",
    transform: "translate(-13177.094 -10232.91)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaBigCircleIcon);
export default __webpack_public_path__ + "static/media/insta-big-circle-icon.69979f75a10c8278c445227857629e1b.svg";
export { ForwardRef as ReactComponent };